/**
 * @generated SignedSource<<af77895962645da63e6be1f1b3095799>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type StartWhen = "ITEM_ADDED" | "ITEM_DELETED" | "ITEM_UPDATED" | "NO_START" | "%future added value";
export type Status = "ACTIVE" | "ARCHIVED" | "DRAFT" | "INACTIVE" | "TEMPLATE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type processDefinitionsQueryFragment$data = {
  readonly content: ReadonlyArray<{
    readonly definitionKey: string;
    readonly definitionName: string;
    readonly definitionVersion: string | null | undefined;
    readonly dirtyFlag: boolean;
    readonly id: string;
    readonly listName: string | null | undefined;
    readonly startWhen: StartWhen;
    readonly status: Status;
  }>;
  readonly pageInfo: {
    readonly " $fragmentSpreads": FragmentRefs<"listPaginationQueryFragment">;
  };
  readonly " $fragmentType": "processDefinitionsQueryFragment";
};
export type processDefinitionsQueryFragment$key = {
  readonly " $data"?: processDefinitionsQueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"processDefinitionsQueryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "processDefinitionsQueryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProcessDefinition",
      "kind": "LinkedField",
      "name": "content",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "definitionKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "definitionName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "definitionVersion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startWhen",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dirtyFlag",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "listName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "listPaginationQueryFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProcessDefinitionPage",
  "abstractKey": null
};

(node as any).hash = "12671f250ca5a6e3c35369d6d5450688";

export default node;
